// ============================================================
// Blitz CRM — Static Configuration Constants (v30.07)
// Extracted from App.jsx — no React dependencies, no logic
// ============================================================

// ── Payment Status ──
export const STATUS_OPTIONS = ["Open", "On the way", "On hold", "Approved to pay", "Paid"];
export const OPEN_STATUSES = ["Open", "On the way", "On hold", "Approved to pay"];
export const TYPE_OPTIONS = ["Affiliate Payment", "Brand Refund"];
export const STATUS_COLORS = {
  Open:              { bg: "#FEF3C7", text: "#92400E", border: "#F59E0B" },
  "On the way":       { bg: "#EEF2FF", text: "#4338CA", border: "#818CF8" },
  "On hold":          { bg: "#FFF7ED", text: "#9A3412", border: "#FDBA74" },
  "Approved to pay":  { bg: "#ECFDF5", text: "#065F46", border: "#34D399" },
  Paid:               { bg: "#ECFDF5", text: "#065F46", border: "#34D399" },
  Pending:            { bg: "#FEF3C7", text: "#92400E", border: "#F59E0B" },
  Received:           { bg: "#ECFDF5", text: "#065F46", border: "#34D399" },
  Refund:             { bg: "#FFF1F2", text: "#9F1239", border: "#FB7185" },
  Cancelled:          { bg: "#FFF1F2", text: "#9F1239", border: "#FB7185" },
  Processing:         { bg: "#EFF6FF", text: "#1D4ED8", border: "#60A5FA" },
};

// ── Customer Payment Status ──
export const CP_STATUS_OPTIONS = ["Open", "Pending", "Received", "Refund"];
export const CP_STATUS_COLORS = {
  Open: { background: "linear-gradient(135deg, #FEF3C7, #FDE68A)", color: "#92400E", border: "1px solid #FDE68A" },
  Pending: { background: "#818CF8", color: "#FFF" },
  Received: { background: "#10B981", color: "#FFF" },
  Refund: { background: "#EF4444", color: "#FFF" },
};
// v32.11.8 (2026-05-27): добавлен "Brand Refund" по запросу Sophia/девочек.
// "Brand Refund" — outflow money (мы возвращаем бренду): overpayment / cancellation /
// fraud reversal. Симметричен "Affiliate Refund" (тоже outflow, но к affiliate).
// В UI оба refund-type'а выделены в отдельные KPI cards (Open Refunds / Paid Refunds)
// и собственные GroupHeader sections, отдельно от Brand Payment (incoming).
// См. src/pages/CustomerPayments/index.jsx REFUND_TYPES для filter classification.
export const CP_TYPE_OPTIONS = ["Brand Payment", "Affiliate Refund", "Brand Refund"];

// ── Partner Status ──
export const PARTNER_DEAL_STATUS = ["Talking", "Negotiate", "Working"];
export const PARTNER_DEAL_STATUS_COLORS = {
  Talking:   { background: "#FEF3C7", color: "#92400E", border: "#FDE68A" },
  Negotiate: { background: "#EEF2FF", color: "#3730A3", border: "#C7D2FE" },
  Working:   { background: "#ECFDF5", color: "#065F46", border: "#6EE7B7" },
};
export const PARTNER_STATUS_COLORS = {
  Brand:     { background: "#6366F1", color: "#FFF" },
  Network:   { background: "#0EA5E9", color: "#FFF" },
  Affiliate: { background: "#10B981", color: "#FFF" },
};
export const PARTNER_ACT_COLORS = {
  CPA:         { background: "#FEF3C7", color: "#92400E" },
  CRG:         { background: "#ECFDF5", color: "#065F46" },
  "CPA + CRG": { background: "#EEF2FF", color: "#3730A3" },
};

// ── Gen Balances Type Colors ──
export const GB_TYPE_COLORS = {
  "TRC":           { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B" },
  "ERC":           { bg: "#EFF6FF", text: "#1E40AF", dot: "#3B82F6" },
  "ETH":           { bg: "#F0F4FF", text: "#3730A3", dot: "#6366F1" },
  "XRP":           { bg: "#E0F2FE", text: "#0369A1", dot: "#0EA5E9" },
  "SOL":           { bg: "#F5F3FF", text: "#6D28D9", dot: "#8B5CF6" },
  "RENDER":        { bg: "#FFF7ED", text: "#C2410C", dot: "#F97316" },
  "BTC":           { bg: "#FFF7ED", text: "#9A3412", dot: "#F97316" },
  "Exodus":        { bg: "#F0FDF4", text: "#166534", dot: "#10B981" },
  "Card":          { bg: "#ECFDF5", text: "#065F46", dot: "#34D399" },
  "Clarity bank":  { bg: "#F5F3FF", text: "#5B21B6", dot: "#8B5CF6" },
  "On the way":    { bg: "#E0E7FF", text: "#3730A3", dot: "#6366F1" },
  "Cash":          { bg: "#ECFDF5", text: "#065F46", dot: "#059669" },
  "Other":         { bg: "#F1F5F9", text: "#475569", dot: "#94A3B8" },
};

// ── Months ──
export const MONTHS = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

// ── Team Names ──
export const TEAM_NAMES_DEFAULT = ["Alex", "John", "Katie", "Joy", "Oksana", "Donald"];

// ── Empty Initial Arrays (prevent hardcoded demo data) ──
export const INITIAL = [];
export const CP_INITIAL = [];
export const CRG_INITIAL = [];
export const DC_INITIAL = [];
export const DEALS_INITIAL = [];

// ── Customer Payments chip palettes (moved verbatim from App.jsx, C1 refactor) ──
// v31.46: chip color mapping для Customer Payments — aligned к existing
// CP_STATUS_COLORS intent (amber/indigo/emerald/red) но в solid flat colors
// для chip-style (dot + text same color). Используется в CPForm + CPTable.
export const CP_STATUS_CHIP = {
  'Open':     { color: '#F59E0B', label: 'Open' },      // amber — pending action
  'Pending':  { color: '#818CF8', label: 'Pending' },   // indigo — in-progress (matches CP_STATUS_COLORS)
  'Received': { color: '#10B981', label: 'Received' },  // emerald — success
  'Refund':   { color: '#EF4444', label: 'Refund' },    // red — reversal
};
// v31.46 / v32.11.8 (2026-05-27): CP type palette. 3 типа разделены на 2 buckets:
//   PAYMENTS bucket (incoming): Brand Payment — brand pays us.
//   REFUNDS bucket (outflow): Affiliate Refund + Brand Refund — we refund counterparty.
// Refunds выделены в собственные KPI cards (Open Refunds / Paid Refunds) и
// GroupHeader sections в CustomerPayments page, не суммируются с Open/Received Total.
// Backward compat: legacy records без type или с type "Customer Payment" → treated
// as Brand Payment (см. isRefundType в pages/CustomerPayments/index.jsx).
//   - Brand Payment: sky #0EA5E9 (incoming)
//   - Affiliate Refund: orange #F97316 (outflow — refund к affiliate)
//   - Brand Refund: red #EF4444 (outflow — refund к brand) — matches PAYMENT_TYPE_CHIP
//     в Affiliate Payments page для visual consistency между двумя finance modals.
export const CP_TYPE_CHIP = {
  'Brand Payment':    { color: '#0EA5E9', label: 'Brand Payment' },
  'Affiliate Refund': { color: '#F97316', label: 'Affiliate Refund' },
  'Brand Refund':     { color: '#EF4444', label: 'Brand Refund' },
};
